//LIBRARY
import React from "react";

//RENDER

//CONSTANTS
import {
  TEXT_JUST_CLICK_ON,
  TEXT_SELECT_PROGRAM,
} from "../../../utils/useConstants";

import {
  STYLE_HEADING_2,
  STYLE_PADDING_WINDOWS,
  STYLE_SELECT_PROGRAM_TITLE,
  STYLE_UNDERLINE_BLUE_SELECTPROGRAM,
  STYLE_LINK_BLUE,
} from "../../../utils/useStyle";

//CONTEXT
import { ContextLanguage } from "../../../context/Context.Language";

//FUNCTION
import IconInfoWithModalMain from "../../../components/IconInfoWithModal/IconInfoWithModal.Main";
import HomeRenderEachProgram from "./Home.RenderEachProgram";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../utils/useIsMobile";
import HomeLaudryService from "./Home.LandryService";

const HomeProgram = React.memo(({ programs, config }) => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div>
        <div
          id="scroll_select_program"
          className={`${STYLE_PADDING_WINDOWS} pt-5  pb-5 md:pt-[80px]  `}
        >
          {/* <div
            className={`${STYLE_HEADING_2(
              language
            )} ${STYLE_SELECT_PROGRAM_TITLE}`}
          >
            {TEXT_SELECT_PROGRAM[language]}
          </div> */}
          {/* <IconInfoWithModalMain
            classNameIcon={` w-[20px] md:w-7 cursor-pointer text-laundry-gray-100 md:text-laudry-gray-200 hover:text-laundry-primary-blue group`}
            description={config?.program_method_description}
            description2={config?.program_method_description_2}
            image={config?.program_method_image_key_desktop}
            imageMobile={config?.program_method_image_key_mobile}
            modalItitle={config?.program_method_title}
            classNameWrapper={`${STYLE_HEADING_2(
              language
            )} ${STYLE_SELECT_PROGRAM_TITLE}`}
            title={TEXT_SELECT_PROGRAM[language]}
          />
          <div className={STYLE_UNDERLINE_BLUE_SELECTPROGRAM}></div> */}

          {/* <HomeLaudryService /> */}
          <div className="h-6 md:h-10" />

          <HomeRenderEachProgram data={programs} />
        </div>
      </div>
    );
  } else {
    return (
      <div className="max-w-desktop mx-auto mt-6">
        <div
          id="scroll_select_program"
          className={`${STYLE_PADDING_WINDOWS} pt-5 pb-6.5`}
        >
          {/* <IconInfoWithModalMain
            classNameIcon={` w-[20px] md:w-7 cursor-pointer text-laundry-gray-100 md:text-laudry-gray-200 hover:text-laundry-primary-blue group`}
            description={config?.program_method_description}
            description2={config?.program_method_description_2}
            image={config?.program_method_image_key_desktop}
            imageMobile={config?.program_method_image_key_mobile}
            modalItitle={config?.program_method_title}
            classNameWrapper={`${STYLE_HEADING_2(
              language
            )} ${STYLE_SELECT_PROGRAM_TITLE}`}
            title={TEXT_SELECT_PROGRAM[language]}
          />

          <div className={STYLE_UNDERLINE_BLUE_SELECTPROGRAM}></div> */}

          {/* <div
            className={`${
              language === "TH"
                ? " text-sm-th md:text-base-th "
                : " text-sm md:text-base "
            } leading-6 text-laundry-gray-100 text-center `}
          >
            {!isMobile ? (
              <React.Fragment>{TEXT_JUST_CLICK_ON[language]}</React.Fragment>
            ) : (
              <React.Fragment>
                {language === "TH"
                  ? "เริ่มต้นง่ายๆ แค่เลือกบริการที่คุณต้องการด้านล่าง"
                  : "Just click on one of our fully-customisable services below to start. Our promise: we only use highly energy-efficient washing and drying machines from Germany which not only deliver the best washing results but are also friendly to the environment."}
                {language === "TH" && (
                  <div>
                    มายลอนดรี้ให้คุณมั่นใจว่าเราใช้เครื่องซักอบผ้าที่ประหยัดพลังงานสูงสุดจากประเทศเยอรมนี
                    ซึ่งให้ผลลัพธ์ในการ
                    <br />
                    ซักผ้าดีที่สุดและเป็นมิตรต่อสิ่งแวดล้อมด้วย
                  </div>
                )}
              </React.Fragment>
            )}
            <span
              onClick={() => {
                navigate("/AboutUs");
              }}
              className={`${STYLE_LINK_BLUE}  cursor-pointer`}
            >
              #WeWashWithBosch
            </span>
          </div> */}
          {/* <HomeLaudryService /> */}

          <HomeRenderEachProgram data={programs} />
        </div>
      </div>
    );
  }
});
export default HomeProgram;
